import { ObjectManagerDetailProps } from '../ObjectManagerDetail';
import { RelationList } from '../features/relations/components/RelationList';

const Relations = ({ object, onChange }: ObjectManagerDetailProps) => (
  <RelationList object={object} onChange={onChange} />
);

export default Relations;
